var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemPicked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2762 8.39052C26.7969 8.91122 26.7969 9.75544 26.2762 10.2761L14.2762 22.2761C13.7555 22.7968 12.9112 22.7968 12.3905 22.2761L5.72387 15.6095C5.20317 15.0888 5.20317 14.2446 5.72387 13.7239C6.24457 13.2032 7.08879 13.2032 7.60949 13.7239L13.3333 19.4477L24.3905 8.39052C24.9112 7.86983 25.7555 7.86983 26.2762 8.39052Z",
    fill: "#BA9D5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemPicked);
export default __webpack_public_path__ + "static/media/item-picked.798d163b245b3539ef7598f9c465d910.svg";
export { ForwardRef as ReactComponent };